import * as h from "react";
import { i as x, E as b, x as l, a as g, r as f, c as v } from "../createReactComponent-58f9bea8.mjs";
import { n as c } from "../property-9daa16cd.mjs";
import { e as u } from "../class-map-2994e95e.mjs";
import { a as y, S as m, b as p, r as T } from "../segmentedcontrol-a5e8d97c.mjs";
import { r as S } from "../icon-button-87ac6b5d.mjs";
import { r as C } from "../tooltip-cb602d1f.mjs";
import "../icon-c572aa57.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const E = x`
  :host div.segmented-controls--wrapper {
    display: flex;
    align-items: flex-start;
  }

  :host label {
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font);
    display: flex;
    padding: var(--exo-spacing-none) var(--exo-spacing-4x-small);

    align-items: center;
    gap: var(--exo-spacing-2x-small);
    align-self: stretch;
    margin-bottom: var(--exo-spacing-2x-small);
  }

  ::slotted(ex-segmentedcontrol:hover),
  ::slotted(ex-segmentedcontrol:focus-visible) {
    z-index: 2;
  }

  ::slotted(ex-segmentedcontrol:focus) {
    z-index: 1;
  }

  :host .segmented-controls--white ::slotted(ex-segmentedcontrol),
  :host .segmented-controls--gray ::slotted(ex-segmentedcontrol) {
    margin-left: calc(var(--exo-spacing-4x-small) * -1);
  }
`;
var A = Object.defineProperty, w = Object.getOwnPropertyDescriptor, d = (s, e, o, t) => {
  for (var r, n = t > 1 ? void 0 : t ? w(e, o) : e, i = s.length - 1; i >= 0; i--)
    (r = s[i]) && (n = (t ? r(e, o, n) : r(n)) || n);
  return t && n && A(e, o, n), n;
};
class a extends b {
  constructor() {
    super(...arguments), this.variant = y.WHITE, this.label = "", this.infoText = "";
  }
  firstUpdated() {
    this.setSegmentedControls();
  }
  setSegmentedControls() {
    Array.from(this.children).forEach((e, o, t) => {
      e.setAttribute("segmentVariant", this.variant), o === 0 ? e.setAttribute("segmentPlace", m.FIRST) : o === t.length - 1 ? e.setAttribute("segmentPlace", m.LAST) : e.setAttribute("segmentPlace", m.INNER), e.setAttribute("tooltipPlacement", this.label ? p.BOTTOM : p.TOP), e.addEventListener("onSelection", (r) => this.onToggle(r));
    });
  }
  onToggle(e) {
    const o = e.target;
    Array.from(this.children).forEach((t, r) => {
      t === o ? (t.setAttribute("selected", ""), this.dispatchCustomEvent("onSelectionChange", { selectedIndex: r })) : t.removeAttribute("selected");
    });
  }
  dispatchCustomEvent(e, o) {
    const t = new CustomEvent(e, { bubbles: !0, cancelable: !1, composed: !0, detail: o });
    this.dispatchEvent(t);
  }
  renderInfoText() {
    return this.infoText.trim() ? l`
        <ex-icon-button
          icon="information"
          flavor="branded"
          type="tertiary"
          size="x-small"
          circular="true"
          tooltipText=${this.infoText}
        ></ex-icon-button>
      ` : g;
  }
  getLabel() {
    return this.label ? l`<label>${this.label}${this.renderInfoText()}</label>` : g;
  }
  render() {
    return l`${this.getLabel()}
      <div
        class=${u({ "segmented-controls--wrapper": !0, "segmented-controls--white": this.variant === "white", "segmented-controls--gray": this.variant === "gray", "segmented-controls--with-label": this.label })}
      >
        <slot></slot>
      </div>`;
  }
}
a.styles = E, d([c({ type: String })], a.prototype, "variant", 2), d([c({ type: String })], a.prototype, "label", 2), d([c()], a.prototype, "infoText", 2);
const P = (s = "") => {
  f("ex-segmentedcontrols", a, s), T(s), S(s), C(s);
}, B = v({ tagName: "ex-segmentedcontrols", elementClass: a, react: h, events: { onSelectionChange: "onSelectionChange" }, displayName: "ExSegmentedControls", registerWebComponent: P });
export {
  B as ExSegmentedControls,
  P as register
};
